import React from "react";
import cx from "classnames";

let timeout = null;

function Toast({ open = false, type = "success", message }) {
  const toastInput = React.useRef(null);

  if (process.browser) {
    if (open) closeLater(toastInput, type === "error" ? 10000 : 5000);
    else closeNow(toastInput);
  }
  return (
    <label className={cx("toast", type)} style={{ opacity: message ? 1 : 0 }}>
      <input type="checkbox" ref={toastInput} checked={open} />
      <div className="toast-content">
        <div className={`toast-icon-wrapper ${type}`}>
          <img
            className={`toast-icon ${type}`}
            src={`/img/svg/toast-${type}.svg`}
          />
        </div>
        <div className="toast-description">
          <span className={`toast-type-label ${type}`}>
            {`${type.charAt(0).toUpperCase()}${type.slice(1)}`}{" "}
          </span>
          <span className="toast-message-label">
            {message && message.replace(/\\n/g, "\n")}
          </span>
        </div>
        <div className="cross-icon-wrapper">
          <div className="cross-icon"></div>
        </div>
      </div>
    </label>
  );
}

function closeNow(toastInput) {
  if (toastInput.current) toastInput.current.checked = false;
}

function closeLater(toastInput, ms) {
  clearTimeout(timeout);
  timeout = setTimeout(() => {
    closeNow(toastInput);
  }, ms);
}

export default Toast;
